import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';

const UserOnboard = () => {
    const [activeTab, setActiveTab] = useState('personal');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        // password: '',
        first_name: '',
        last_name: '',
        organization_id: '',
        role_id: '',
        name: '',
        code: '',
        industry: '',
        size: '',
        subscription_plan: '',
        role: ''
    });
    const { registerByAdmin, register } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        console.log("forms", e)
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [settings, setSettings] = useState({
        personal: {
            email: 'test@test.test',
            password: 'Test@123',
            first_name: 'Test1',
            last_name: 'Test last',
        },
        email: {
            smtpHost: 'smtp.gmail.com',
            smtpPort: '587',
            smtpUser: '',
            smtpPassword: '',
            fromEmail: 'noreply@ppm.com',
            fromName: 'PPM System'
        },
        security: {
            sessionTimeout: '30',
            passwordMinLength: '8',
            requireSpecialChar: true,
            requireNumber: true,
            requireUppercase: true,
            twoFactorEnabled: false,
            maxLoginAttempts: '5'
        },
        notifications: {
            emailNotifications: true,
            demoRequestNotifications: true,
            newOrganizationNotifications: true,
            paymentNotifications: true,
            systemAlerts: true
        },
        maintenance: {
            maintenanceMode: false,
            maintenanceMessage: 'System is under maintenance. Please check back later.',
            allowedIPs: ''
        }
    });

    useEffect(() => {
        fetchSettings();
    }, []);


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);

    //     try {
    //         console.log("api hitting",formData)
    //         await registerByAdmin(formData);
    //         toast.success('Registration successful!');
    //         // navigate('/admin/users');
    //     } catch (error) {
    //                     console.log("api hitting",error)

    //         toast.error(error.response?.data?.error || 'Registration failed');
    //     } finally {
    //         setLoading(false);
    //     }
    // };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await registerByAdmin(formData);
            toast.success('Registration successful!');
            navigate('/admin/users');
        } catch (error) {
            toast.error(error.response?.data?.error || 'Registration failed');
        } finally {
            setLoading(false);
        }
    };

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            const response = await axios.get(`${API_URL}/api/${API_VERSION}/admin/settings`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.data) {
                setSettings(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
            // Use default settings if API fails
        }
    };

    const handleInputChange = (section, field, value) => {
        setSettings(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleSave = async (section) => {
        setLoading(true);
        try {
            // await register(formData);
            toast.success('Form saved successfully');
        } catch (error) {
            console.error('Error saving settings:', error);
            toast.error('Failed to save settings');
        } finally {
            setLoading(false);
        }
    };

    const renderGeneralSettings = () => (
        <div className="settings-section">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Personal</h2>

                <div className="settings-form">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block mb-2">First Name</label>
                            <input
                                type="text"
                                name="first_name"
                                placeholder="John"
                                value={formData.first_name}
                                onChange={handleChange}
                                className="w-full border rounded px-3 py-2"
                            />
                        </div>

                        <div>
                            <label className="block mb-2">Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                placeholder="Doe"
                                value={formData.last_name}
                                onChange={handleChange}
                                className="w-full border rounded px-3 py-2"
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder="johndoe@example.com"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>

                    </div>

                    <h2>Organisation</h2>

                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        <div className="form-group ">
                            <label>Organisation Name</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Jojo techland"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group ">
                            <label>Code</label>
                            <input
                                type="text"
                                placeholder="Jojo12345"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Role
                            </label>

                            <select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Select Role</option>
                                <option value="Admin">Admin</option>
                                <option value="Super Admin">Super Admin</option>
                                <option value="User">User</option>
                                <option value="Manager">Manager</option>
                                <option value="Mamber">Member</option>
                            </select>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        <div className="form-group ">
                            <label>Industry</label>
                            <input
                                type="text"
                                name="industry"
                                placeholder="IT"
                                value={formData.industry}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                size
                            </label>
                            <select
                                name="size"
                                value={formData.size}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="Small">Small (1 - 100)</option>
                                <option value="Medium">Medium (101 - 500)</option>
                                <option value="Large">Large (501 - 5000)</option>
                                <option value="Enterprise">Enterprise (5001+)</option>
                                {/* {issueService.getStatuses().map(status => (
                                    <option key={status} value={status}>{status}</option>
                                ))} */}
                            </select>
                        </div>


                        <div className="form-group">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Subscription Plan
                            </label>
                            <select
                                name="subscription_plan"
                                value={formData.subscription_plan}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="Free">Free</option>
                                <option value="Basic">Basic</option>
                                <option value="Enterprise">Enterprise</option>
                                <option value="Professional">Professional</option>

                                {/* {issueService.getStatuses().map(status => (
                                    <option key={status} value={status}>{status}</option>
                                ))} */}
                            </select>
                        </div>
                    </div>

                    <button className="btn-save" type='submit' disabled={loading}>
                        {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>

            </form>
        </div>
    );

    const renderEmailSettings = () => (
        <div className="settings-section">
            <h2>Email Configuration</h2>
            <div className="settings-form">
                <div className="form-group">
                    <label>SMTP Host</label>
                    <input
                        type="text"
                        value={settings.email.smtpHost}
                        onChange={(e) => handleInputChange('email', 'smtpHost', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>SMTP Port</label>
                    <input
                        type="text"
                        value={settings.email.smtpPort}
                        onChange={(e) => handleInputChange('email', 'smtpPort', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>SMTP Username</label>
                    <input
                        type="text"
                        value={settings.email.smtpUser}
                        onChange={(e) => handleInputChange('email', 'smtpUser', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>SMTP Password</label>
                    <input
                        type="password"
                        value={settings.email.smtpPassword}
                        onChange={(e) => handleInputChange('email', 'smtpPassword', e.target.value)}
                        placeholder="••••••••"
                    />
                </div>
                <div className="form-group">
                    <label>From Email</label>
                    <input
                        type="email"
                        value={settings.email.fromEmail}
                        onChange={(e) => handleInputChange('email', 'fromEmail', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>From Name</label>
                    <input
                        type="text"
                        value={settings.email.fromName}
                        onChange={(e) => handleInputChange('email', 'fromName', e.target.value)}
                    />
                </div>
                <button className="btn-save" onClick={() => handleSave('email')} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </div>
    );

    const renderSecuritySettings = () => (
        <div className="settings-section">
            <h2>Security Settings</h2>
            <div className="settings-form">
                <div className="form-group">
                    <label>Session Timeout (minutes)</label>
                    <input
                        type="number"
                        value={settings.security.sessionTimeout}
                        onChange={(e) => handleInputChange('security', 'sessionTimeout', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Password Minimum Length</label>
                    <input
                        type="number"
                        value={settings.security.passwordMinLength}
                        onChange={(e) => handleInputChange('security', 'passwordMinLength', e.target.value)}
                    />
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.security.requireSpecialChar}
                            onChange={(e) => handleInputChange('security', 'requireSpecialChar', e.target.checked)}
                        />
                        Require Special Character
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.security.requireNumber}
                            onChange={(e) => handleInputChange('security', 'requireNumber', e.target.checked)}
                        />
                        Require Number
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.security.requireUppercase}
                            onChange={(e) => handleInputChange('security', 'requireUppercase', e.target.checked)}
                        />
                        Require Uppercase Letter
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.security.twoFactorEnabled}
                            onChange={(e) => handleInputChange('security', 'twoFactorEnabled', e.target.checked)}
                        />
                        Enable Two-Factor Authentication
                    </label>
                </div>
                <div className="form-group">
                    <label>Max Login Attempts</label>
                    <input
                        type="number"
                        value={settings.security.maxLoginAttempts}
                        onChange={(e) => handleInputChange('security', 'maxLoginAttempts', e.target.value)}
                    />
                </div>
                <button className="btn-save" onClick={() => handleSave('security')} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </div>
    );

    const renderNotificationSettings = () => (
        <div className="settings-section">
            <h2>Notification Settings</h2>
            <div className="settings-form">
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.notifications.emailNotifications}
                            onChange={(e) => handleInputChange('notifications', 'emailNotifications', e.target.checked)}
                        />
                        Enable Email Notifications
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.notifications.demoRequestNotifications}
                            onChange={(e) => handleInputChange('notifications', 'demoRequestNotifications', e.target.checked)}
                        />
                        Demo Request Notifications
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.notifications.newOrganizationNotifications}
                            onChange={(e) => handleInputChange('notifications', 'newOrganizationNotifications', e.target.checked)}
                        />
                        New Organization Notifications
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.notifications.paymentNotifications}
                            onChange={(e) => handleInputChange('notifications', 'paymentNotifications', e.target.checked)}
                        />
                        Payment Notifications
                    </label>
                </div>
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.notifications.systemAlerts}
                            onChange={(e) => handleInputChange('notifications', 'systemAlerts', e.target.checked)}
                        />
                        System Alerts
                    </label>
                </div>
                <button className="btn-save" onClick={() => handleSave('notifications')} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </div>
    );

    const renderMaintenanceSettings = () => (
        <div className="settings-section">
            <h2>Maintenance Mode</h2>
            <div className="settings-form">
                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={settings.maintenance.maintenanceMode}
                            onChange={(e) => handleInputChange('maintenance', 'maintenanceMode', e.target.checked)}
                        />
                        Enable Maintenance Mode
                    </label>
                    <small>When enabled, only admins can access the system</small>
                </div>
                <div className="form-group">
                    <label>Maintenance Message</label>
                    <textarea
                        rows="3"
                        value={settings.maintenance.maintenanceMessage}
                        onChange={(e) => handleInputChange('maintenance', 'maintenanceMessage', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Allowed IP Addresses (comma-separated)</label>
                    <textarea
                        rows="2"
                        value={settings.maintenance.allowedIPs}
                        onChange={(e) => handleInputChange('maintenance', 'allowedIPs', e.target.value)}
                        placeholder="192.168.1.1, 10.0.0.1"
                    />
                    <small>Leave empty to allow all IPs during maintenance</small>
                </div>
                <button className="btn-save" onClick={() => handleSave('maintenance')} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </div>
    );

    return (
        <div className="admin-settings">
            <div className="page-header">
                <h1>Add User</h1>
                {/* <p>Configure system-wide settings and preferences</p> */}
            </div>

            <div className="settings-container">
                <div className="settings-tabs">
                    <button
                        className={activeTab === 'personal' ? 'active' : ''}
                        onClick={() => setActiveTab('personal')}
                    >
                        <i className="fas fa-cog"></i>
                        Personal
                    </button>
                    {/* <button
                        className={activeTab === 'email' ? 'active' : ''}
                        onClick={() => setActiveTab('email')}
                    >
                        <i className="fas fa-envelope"></i>
                        Email
                    </button>
                    <button
                        className={activeTab === 'security' ? 'active' : ''}
                        onClick={() => setActiveTab('security')}
                    >
                        <i className="fas fa-shield-alt"></i>
                        Security
                    </button>
                    <button
                        className={activeTab === 'notifications' ? 'active' : ''}
                        onClick={() => setActiveTab('notifications')}
                    >
                        <i className="fas fa-bell"></i>
                        Notifications
                    </button>
                    <button
                        className={activeTab === 'maintenance' ? 'active' : ''}
                        onClick={() => setActiveTab('maintenance')}
                    >
                        <i className="fas fa-tools"></i>
                        Maintenance
                    </button> */}
                </div>

                <div className="settings-content">
                    {activeTab === 'personal' && renderGeneralSettings()}
                    {/* {activeTab === 'email' && renderEmailSettings()}
                    {activeTab === 'security' && renderSecuritySettings()}
                    {activeTab === 'notifications' && renderNotificationSettings()}
                    {activeTab === 'maintenance' && renderMaintenanceSettings()} */}
                </div>
            </div>
        </div>
    );
};


//  <div className="form-group">
//                             <label>Password</label>
//                             <input
//                                 type="password"
//                                 value={formData.password}
//                                 name="password"
//                                 onChange={handleChange}
//                                 placeholder="Create a strong password"
//                             />
//                         </div>

export default UserOnboard;


